import { selectJBPSettingsCurrentFYear } from 'legacy/lut/features/partner360/jbpSettings'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Dropdown } from 'core-components/library/dropdown'
import { BaseCrud, Static } from 'core-components/types'

interface IBusinessPrioritiesFYearSelectProps {
  fYear: number
  onChange: (fYear: number) => void
}

export const BusinessPrioritiesFYearSelect: FC<IBusinessPrioritiesFYearSelectProps> = ({
  fYear,
  onChange,
}) => {
  const currentFYear = useSelector(selectJBPSettingsCurrentFYear)

  const source = useMemo(() => {
    if (!currentFYear) {
      return null
    }

    const crud = new BaseCrud({
      fetcher: new Static([
        { value: currentFYear, text: String(currentFYear) },
        { value: currentFYear - 1, text: String(currentFYear - 1) },
      ]),
      keyField: 'value',
    })

    crud.setPaging({ page: 0, pageSize: 10 })

    return crud
  }, [currentFYear])

  if (!source || !fYear) {
    return null
  }

  return (
    <Dropdown
      source={source}
      caption="text"
      value={fYear}
      onChange={(value) => onChange(Number(value))}
    />
  )
}

BusinessPrioritiesFYearSelect.displayName = 'BusinessPrioritiesFYearSelect'

export default BusinessPrioritiesFYearSelect
